export function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) return;

  const appOrigin = new URL(import.meta.url).origin;
  if (appOrigin !== window.location.origin) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register(new URL(/* @vite-ignore */ "sw.js", import.meta.url).href).catch((error) => {
      console.warn("No se pudo registrar el service worker.", error);
    });
  });
}
